export function Logo({ size = 36, showWordmark = true, subtitle = true }) {
    // Simple O with diagonal cut at top — green accent, matching site palette.
    return (
        <div className="flex items-center gap-3 select-none" data-testid="unveiled-logo">
            <svg
                width={size}
                height={size}
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden
            >
                <defs>
                    <mask id="ulMask">
                        <rect width="64" height="64" fill="white" />
                        {/* Diagonal cut at the top */}
                        <polygon points="34,2 62,2 62,14 44,14" fill="black" />
                    </mask>
                </defs>
                <g mask="url(#ulMask)">
                    <circle
                        cx="32" cy="32" r="24"
                        fill="none"
                        stroke="var(--ok-accent)"
                        strokeWidth="7"
                        strokeLinecap="round"
                    />
                </g>
            </svg>
            {showWordmark && (
                <div className="leading-none">
                    {subtitle && (
                        <div className="font-mono text-[7px] uppercase tracking-[0.4em] opacity-25 mb-1">
                            Project
                        </div>
                    )}
                    <div className="font-display font-bold tracking-[0.22em] text-[1.25rem]">
                        UNVEILED
                    </div>
                </div>
            )}
        </div>
    );
}
